import Highcharts from 'highcharts';
import translate from '../common/localization/translate';

function calculateCosPhi(value) {
  if (value === null) {
    return value;
  }
  const modifiedValue = value * -1;
  return modifiedValue <= 0 ? modifiedValue + 1.0 : modifiedValue - 1.0;
}

function formatCosPhi(value, decimals) {
  const label = value >= 0 ? 'evaluation.OVEREXCITED' : 'evaluation.UNDEREXCITED';
  const suffix = `<sub>${translate(label)}</sub>`;
  const modifiedValue = calculateCosPhi(value);
  if (modifiedValue === 1.0) {
    return modifiedValue;
  }
  return `${Highcharts.numberFormat(Math.abs(modifiedValue), decimals)}${suffix}`;
}

const CosPhiService = {
  calculateCosPhi,
  formatCosPhi,
};

export default CosPhiService;
